/* Snout & Story motion layer */
(function () {
  if (window.__snsMotionReady) return;
  window.__snsMotionReady = true;

  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var motion = root.classList.contains('sns-motion');

  var REVEAL = [
    'main .shopify-section:not(:first-child) .text-block:not(marquee-component *):not(product-card *)',
    'main .shopify-section:not(:first-child) .image-block:not(product-card *)',
    'main .shopify-section:not(:first-child) .icon-block:not(marquee-component *)',
    'main .shopify-section:not(:first-child) accordion-custom',
    'main .resource-list__item'
  ].join(',');

  /* ---------- Reveal on scroll ---------- */
  var io = null;
  if (motion && 'IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        io.unobserve(el);
        el.classList.add('sns-in');
        var delay = parseFloat(el.style.getPropertyValue('--sns-d')) || 0;
        setTimeout(function () { el.classList.add('sns-done'); }, delay * 1000 + 950);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
  }

  function setupReveal(scope) {
    var nodes = (scope || document).querySelectorAll(REVEAL);
    nodes.forEach(function (el) {
      if (el.__sns) return;
      el.__sns = true;
      if (!io) { el.classList.add('sns-in', 'sns-done'); return; }
      var parent = el.parentElement;
      var i = 0;
      if (parent) {
        var sibs = Array.prototype.filter.call(parent.children, function (c) { return c.matches && c.matches(REVEAL); });
        i = Math.max(0, sibs.indexOf(el));
      }
      el.style.setProperty('--sns-d', (Math.min(i, 6) * 0.09).toFixed(2) + 's');
      io.observe(el);
    });
  }

  /* ---------- Cards with a white background lift on hover ---------- */
  function setupCards(scope) {
    (scope || document).querySelectorAll('main .group-block').forEach(function (g) {
      if (g.__snsCard) return;
      g.__snsCard = true;
      var bg = getComputedStyle(g).backgroundColor;
      if (bg === 'rgb(255, 255, 255)' && g.querySelector('.image-block')) g.classList.add('sns-card');
    });
  }

  /* ---------- Shine layer inside link buttons ---------- */
  function setupShine(scope) {
    (scope || document).querySelectorAll('main a.button').forEach(function (b) {
      if (b.querySelector('.sns-shine')) return;
      var s = document.createElement('span');
      s.className = 'sns-shine';
      s.setAttribute('aria-hidden', 'true');
      b.appendChild(s);
    });
  }

  /* ---------- Gentle parallax on large images ---------- */
  var plx = [];
  function setupParallax() {
    plx = [];
    document.querySelectorAll('main .shopify-section:not(:first-child) .image-block:not(product-card *)').forEach(function (b) {
      if (b.closest('.sns-card')) return;
      if (b.getBoundingClientRect().width < window.innerWidth * 0.35) return;
      b.classList.add('sns-plx');
      var img = b.querySelector('img');
      if (img) plx.push(img);
    });
  }
  var lastCheck = 0;
  function sweep() {
    /* Safety net: reveal anything already on screen that the observer missed */
    var now = Date.now();
    if (now - lastCheck < 400) return;
    lastCheck = now;
    var vh = window.innerHeight;
    document.querySelectorAll('main [style*="--sns-d"]:not(.sns-in)').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.height > 0 && r.top < vh * 0.94 && r.bottom > 0) {
        el.classList.add('sns-in');
        setTimeout(function () { el.classList.add('sns-done'); }, 1000);
      }
    });
  }
  var ticking = false;
  function onScroll() {
    var sc = document.querySelector('.page-wrapper');
    var y = window.scrollY || (sc ? sc.scrollTop : 0) || 0;
    root.classList.toggle('sns-scrolled', y > 12);
    if (motion) sweep();
    if (!motion || ticking || !plx.length) return;
    ticking = true;
    requestAnimationFrame(function () {
      var vh = window.innerHeight;
      plx.forEach(function (img) {
        var r = img.getBoundingClientRect();
        if (r.bottom < -100 || r.top > vh + 100) return;
        var off = ((r.top + r.height / 2) - vh / 2) * -0.06;
        off = Math.max(-28, Math.min(28, off));
        img.style.setProperty('--sns-py', off.toFixed(1) + 'px');
      });
      ticking = false;
    });
  }

  /* ---------- Click ripple + paw/heart burst ---------- */
  var PAW = '<svg viewBox="0 0 24 24" fill="currentColor"><ellipse cx="12" cy="16" rx="5" ry="4.2"/><circle cx="6" cy="10" r="2.2"/><circle cx="9.5" cy="6.5" r="2.2"/><circle cx="14.5" cy="6.5" r="2.2"/><circle cx="18" cy="10" r="2.2"/></svg>';
  var HEART = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 21s-7.2-4.4-9.6-8.6C.6 8.6 3 5 6.6 5c2 0 3.6 1.1 5.4 3 1.8-1.9 3.4-3 5.4-3 3.6 0 6 3.6 4.2 7.4C19.2 16.6 12 21 12 21z"/></svg>';
  var COLORS = ['#B4532A', '#E08A6B', '#D9A441', '#C25B7A', '#2B2420'];

  function burst(x, y) {
    if (!motion) return;
    for (var i = 0; i < 9; i++) {
      var p = document.createElement('span');
      p.className = 'sns-burst';
      p.innerHTML = i % 3 === 0 ? HEART : PAW;
      var ang = (Math.PI * 2 * i) / 9 + Math.random() * 0.5;
      var dist = 46 + Math.random() * 46;
      p.style.color = COLORS[i % COLORS.length];
      p.style.setProperty('--sx', (x - 9) + 'px');
      p.style.setProperty('--sy', (y - 9) + 'px');
      p.style.setProperty('--ex', (x - 9 + Math.cos(ang) * dist) + 'px');
      p.style.setProperty('--ey', (y - 9 + Math.sin(ang) * dist - 24) + 'px');
      p.style.setProperty('--r', (Math.random() * 120 - 60).toFixed(0) + 'deg');
      document.body.appendChild(p);
      setTimeout(function (n) { return function () { n.remove(); }; }(p), 1000);
    }
  }

  function ripple(el, e) {
    var r = el.getBoundingClientRect();
    var size = Math.max(r.width, r.height) * 2.2;
    var s = document.createElement('span');
    s.className = 'sns-ripple';
    s.style.width = s.style.height = size + 'px';
    s.style.left = (e.clientX - r.left - size / 2) + 'px';
    s.style.top = (e.clientY - r.top - size / 2) + 'px';
    if (getComputedStyle(el).position === 'static') el.classList.add('sns-ripple-host');
    else el.style.overflow = 'hidden';
    el.appendChild(s);
    setTimeout(function () { s.remove(); }, 700);
  }

  document.addEventListener('pointerdown', function (e) {
    if (reduce) return;
    var btn = e.target.closest && e.target.closest('.button, .button-secondary, button.add-to-cart-button, button[name="add"]');
    if (!btn) return;
    ripple(btn, e);
    var cta = btn.matches('main a.button, button.add-to-cart-button, button[name="add"]') ||
      /personali[sz]e/i.test(btn.textContent || '');
    if (cta) burst(e.clientX, e.clientY);
  }, { passive: true });

  /* Cart bubble bounce when something is added */
  document.addEventListener('cart:update', function () {
    var bubble = document.querySelector('.cart-bubble, cart-icon, .header-actions__cart-icon');
    if (!bubble || reduce) return;
    bubble.classList.remove('sns-bounce');
    void bubble.offsetWidth;
    bubble.classList.add('sns-bounce');
  });

  function init(scope) {
    setupCards(scope);
    setupReveal(scope);
    setupShine(scope);
  }

  function start() {
    init(document);
    setupParallax();
    onScroll();
    setTimeout(function () { lastCheck = 0; sweep(); }, 1500);
    /* Horizon scrolls inside .page-wrapper: listen in capture phase to catch any scroller */
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
    window.addEventListener('resize', function () { setupParallax(); onScroll(); });
    var main = document.querySelector('main');
    if (main && 'MutationObserver' in window) {
      new MutationObserver(function (muts) {
        muts.forEach(function (m) {
          m.addedNodes.forEach(function (n) { if (n.nodeType === 1) init(n.parentElement || document); });
        });
      }).observe(main, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
